import CONFIRM_DIALOGS from './confirm-dialog/en';
import ERROR_DIALOGS from "./error-dialog/en";
import RESULT_DIALOGS from "./result-dialog/en";
import AGENCY_SETTINGS from './agency-settings/en';

export default {
    BUTTONS: {
        SUBMIT: "Submit",
        PREVIOUS: "Previous",
        NEXT: "Next",
        VIEW: "View",
        UPLOAD: "Upload",
        UPLOAD_FILE: "Upload File",
        VIEW_FILE: "View File",
        DELETE_FILE: "Delete File",
        CLOSE: "Close",
        DELETE: "Delete",
        CANCEL: "Cancel",
        YES: "Yes",
        NO: "No",
        OK: "Ok",
        ADD: "Add",
        UPDATE_STATUS: "Update Status",
        RETURN_DASHBOARD: "Return to Dashboard",
        REFRESH: "Refresh",
        BULK_UPDATE_STATUS: "Update Status of Selected",
        BULK_OVERWRITE_LOCATIONS: "Overwrite Locations",
        BULK_OVERWRITE_TYPES: "Overwrite Types",
        BULK_OVERWRITE_TAGS: "Overwrite Tags",
        BULK_ADD_LOCATIONS: "Add Locations",
        BULK_ADD_TYPES: "Add Types",
        BULK_ADD_TAGS: "Add Tags",
        BULK_UPDATE: "Bulk Update",
        CHARGE_THROUGH_AUTHORIZE_NET: "Charge Through Authorize.Net",
        CHARGE_THROUGH_STRIPE: "Charge Through Stripe",
        INVOICE_THROUGH_STRIPE: "Invoice Through Stripe",
        ADD_USER_TO_MAILCHIMP: "Add {0} Users to Mailchimp",
        CHARGE_CLIENT_AND_PAYOUT_CANDIDATE: "Charge Client and Payout Candidate",
        BULK_COPY_SUGGESTED_CHARGE: "Bulk Copy Suggested Charge to Total Client Charge",
        BULK_DELETE: "Delete Selected",
        BULK_UNASSIGNED: "Unassign Selected",
        EXPORT_EMPLOYERS: "Export Client Mailing List",
        EXPORT_CANDIDATES: "Export Candidate Mailing List",
        UPDATE_MANAGER: "Update {0}",
        VIEW_PROFILE: "View Profile",
        VIEW_OFFER: "View Offer",
        SAVE: "Save",
        EXPAND_ALL: "Expand All",
        COLLAPSE_ALL: "Collapse All",
        SELECT_ALL: "Select All",
        UNSELECT_ALL: "Unselect All",
        RESET_FILTERS: "Reset Filters",
        CLOCK_IN: "Clock In",
        ADD_A_BREAK: "Add a Break",
        CLOCK_OUT: "Clock Out",
        CONFIRM_CLOCK_IN_OUT: "Client Confirm",
        LEAVE_REVIEW: "Leave a Review",
        DECLINE: "Decline",
        DECLINE_WITHOUT_NOTIFICATION: "Decline Without Notification",
        UNDECLINE: "Undecline",
        ACCEPT: "Accept",
        CHECK_PAYMENT: "Check Payment Expression",
        CREATE_SNAPSHOT_APPLICATION_FORM: "Save Current Application Form",
        RESTORE_APPLICATION_FORM: "Restore Saved Application Version",
        RETURNING_APPLICANT: "I am a returning applicant",
        ASSIGN: "Assign",
        TENTATIVELY_ASSIGN: "Tentatively Assign",
        SIGN: "Sign",
        EDIT: "Edit",
        DUPLICATE: "Duplicate",
        ADD_ADDITIONAL_DATES: "Add Additional Dates",
        ADD_A_BOOKING: "Add a Booking",
        ADD_A_GROUP: "Add a Group",
        MESSAGE: "Message",
        UPDATE_CUSTOM_STATUS: "Update {0} Status",
        UPDATE: "Update",
        ADD_OPTION: "Add Option",
        EDIT_SETTING: "Edit Settings",
        DONE: "Done",
        SUBMIT_REPORT: "Submit Report",
        REVIEW_REPORT_BUTTON: "View Reported Problems",
        SEARCH_CANDIDATES_FOR_ALL_BOOKING: "Search for candidates available for all open bookings",
        SHARE_WITH_MARKET_PLACE: "Share With the Agency Marketplace",
        CUSTOMIZE_TEMPLATE: "Customize Template"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "New Status",
        NEW_LOCATIONS: "New Locations",
        NEW_TYPES: "New Types",
        NEW_TAGS: "New Tags",
        FILTER_BY_STATUS: "Filter by Status",
        FILTER_BY_STATUSES: "Filter by Statuses",
        FILTER_BY: "Filter by {0}",
        STATUSES_TO_HIDE: "Statuses to Hide",
        FILTER_BY_LOCATIONS: "Filter by Locations",
        FILTER_BY_DURATIONS: "Filter by Durations",
        FILTER_BY_ROLES: "Filter by Roles",
        FILTER_BY_TYPES: "Filter by Types",
        FILTER_BY_TAGS: "Filter by Tags",
        FILTER_BY_MANAGER: "Filter by Manager",
        FILTER_BY_CLIENT: "Filter by Client",
        FILTER_BY_CATEGORIES: "Filter by Categories",
        FILTER_BY_START_DATE: "Filter by Start Date",
        FILTER_BY_END_DATE: "Filter by End Date",
        FILTER_BY_WEEK_DAY: "Filter by Week Day",
        FILTER_BY_CLIENTS: "Filter by Clients",
        FILTER_BY_CLIENT_STATUSES: "Filter by Client Statuses",
        FILTER_BY_CLIENT_TYPES: "Filter by Client Types",
        FILTER_BY_CANDIDATES: "Filter by Candidate(s)",
        FILTER_BY_JOB_TYPES: "Filter by Job Types",
        FILTER_BY_JOB_STATUSES: "Filter by Job Statuses",
        FILTER_BY_JOB_ID: "Filter by Job ID",
        SELECT_SCRAPER_ACCOUNTS: "Select Scraper Accounts",
        FILTER_BY_USER_TYPE: "Filter by User Type",
        KEYWORD_SEARCH_USER_PROFILE: "Search for keyword/phrase anywhere on user profile, hit Enter to apply search",
        SEARCH_BY_NAME_EMAIL_PHONE: "Search by Name, Email or Phone Number",
        FILTER_BY_RECENT_ACTIVE: "Filter by Recently Active",
        SELECT_LOCATIONS: "Select Locations",
        SELECT_OPTION: "Select Option",
        SELECT_CLIENT: "Select Client",
        SELECT_CANDIDATE: "Select Candidate",
        SELECT_CANDIDATES: "Select Candidates",
        SELECT_CANDIDATE_SEARCHABLE: "Select Candidate (Type to search)",
        SELECT_ADMINS: "Select Admins",
        SELECT_ADMIN_RECEIVE_EMAIL: "Select admins who receive emails",
        SELECT_STATUS: "Select Status",
        SELECT_LANGUAGES: "Select Languages",
        SELECT_TYPES: "Select Types",
        SELECT_TYPE: "Select Type",
        SELECT_AUDIENCE: "Select Audience",
        SELECT_TAGS: "Select Tags",
        SELECT_USER_TYPE: "Select User Type",
        SELECT_USER_TYPES: "Select User Types",
        SELECT_CATEGORY: "Select Category",
        SELECT_CATEGORY_ADMIN_ONLY: "Select Category (Admin Only)",
        SELECT_TRIGGER: "Select Trigger",
        SELECT_ONE: "Select One",
        SELECT_PROFILE_BUILDER: "Select Profile Builder",
        SELECT_TIME_OFF_CATEOGRY: "Select Time Off Category",
        SELECT_DESTINATION: "Select Destination",
        SELECT_ACCESS_LEVEL: "Select Access Level",
        SELECT_VISIBILITY_SCOPE: "Select Visibility Scope",
        SELECT_AREAS: "Select Areas",
        NUMBER: "Number",
        DESCRIPTION_CHARGE: "Description of charge (this description will be included on the user's receipt)",
    },
    LABELS: {
        SELECT_TEMPLATE: "Select Template",
        SELECT_ANALYTICS_DASHBOARD_FIELDS: "Select fields for analytics",
        FILTER_BY_LOCATIONS: "Filter by Locations",
        FILTER_BY_TYPES: "Filter by Types",
        FILTER_BY_MANAGER: "Filter by Manager",
        FILTER_BY_CLIENT: "Filter by Client",
        FILTER_BY_CATEGORIES: "Filter by Categories",
        FILTER_BY_STATUS: "Filter by Status",
        ADDRESS: "Address",
        CITY: "City",
        STATE: "State",
        COUNTRY: "Country",
        ZIP_CODE: "Zip Code",
        LOCATIONS: "Locations",
        DESCRIPTION: "Description",
        PER_HOUR: "per hour",
        ADD_ITEM: "Add {0}",
        EDIT_ITEM: "Edit {0}",
        SAVE_AND_ADD_ANOTHER_ITEM: "Save and Add another {0}",
        WELCOME_TEXT: "Welcome to {0}"
    },
    HEADERS: {
        EMAIL_LOG: "Email Log",
        SMS_LOG: "SMS Log"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "How to hide statuses by default",
        HOW_TO_CHANGE_STATUS: "How to add/change statuses"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Separate multiple emails with ; (eg: nanny1@hotmail.com; nanny2@hotmail.com )",
        SMS_NOTE: `Please note that there is a cost of $0.0115 (1.15¢) per 160 characters of sent/received SMS.`,
        SMS_COUNTER_NOTE: `The exact character count will depend on the information inserted into the actual message.`,
        CLIENT_NOT_ENTERED_STRIPE: "Client has not entered Stripe information.",
        CLIENT_NOT_ENTERED_AUTHORIZE_NET: "Client has not entered Authorize.Net information.",
        CANDIDATE_NOT_ENTERED_STRIPE: "Candidate has not entered Stripe information.",
        INTERVIEW_PANEL: `Note: These notes are for internal administrator use only and are not
        shared with candidates or clients.`,
        CANDIDATE_SHAREABLE_LINK: `This is a shareable link of the candidate profile. If you want
        to see what a client will see, <strong>make sure you log out</strong> and then
        view the link (or open it in a different browser). This is <strong>not</strong> a link for your candidate to log in with. <a href="https://youtu.be/WXjyLdF12O0" target="_blank">Learn more.</a>`,
        CLIENT_SHAREABLE_LINK: `This is a shareable link of the client profile. If you want to
        see what a candidate will see, <strong>make sure you log out</strong> and then
        view the link (or open it in a different browser). This is <strong>not</strong> a link for your clients to log in with. <a href="https://youtu.be/WXjyLdF12O0" target="_blank">Learn more.</a>`,
        CLIENT_PUBLIC_PAYMENT_LINK: `This is a public payment link. Client can access to this link to input payment information without logging in`,
        TYPE_YOUR_NAME_TO_SIGN: 'Please type your name to sign (you agree that this constitutes the equivalent of signing a physical document)',
        JOB_BOARD_ADMIN_VIEW_WARNING: 'You are viewing this job board as an admin. If you want to see it from the perspective of a candidate please open it in a different browser or incognito window. If you need help embedding this into your website please get in touch with us!'
    },
    TABLE_HEADERS: {
        ACTIONS: "Actions",
        NOTES: "Notes",
        VALUE: "Value",
        EFFECTIVE_FROM: "Effective From",
        EFFECTIVE_UNTIL: "Effective Until",
        TYPE: "Type",
        CATEGORIES: "Categories"
    },
    OPTIONS: {
        "YES": "Yes",
        "NO": "No"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "This field is required."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Thank You!",
        STEP_OF: "Step {0} of {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Please help us to fill the form below",
        REFERENCE_FOR: "Reference for {0} {1}",
        REFERENCE_INPUT_BY: "Reference Information inputted by {0} {1}",
        FORM_SUBMITTED: "The reference check form has been submitted!"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Drop a file here or click to upload",
        MAXIMUM_UPLOAD_SIZE: "Maximum upload size {0}MB",
        FILE_EXCEED_MAXIMUM: "File size exceeds {0}MB.",
        FILE: "File"
    },
    BOOKING_SECTION: {
        LABEL: {
            BOOKINGS: "Bookings",
            HIDE_PAST_BOOKINGS: "Hide past bookings",
            BOOKING_CREDIT_LEFT: "{0} booking credits left",
            MIN_BOOKING_REQUIRE: "You need at least {0} booking!",
            MIN_BOOKINGS_REQUIRE: "You need at least {0} bookings!",
            SELECTED_CANDIDATE: "Selected Candidate",
            TOTAL_BOOKING_FEE: "Total Booking Fee",
            BOOKING_GROUPS: "Booking Groups"
        },
        DESCRIPTION: {
            CLICK_ON_BOOKING: "Please click on the booking (on calendar) to learn more about your assigned service provider and leave a review.",
            CLICK_ON_DATE: "Please click a date to add a booking.",
            CLICK_ON_OTHER_DATE: "Please click another date on the calendar to add a booking.",
            BOOKING_GROUP: "All bookings in the same group must be assigned to one assignee"
        },
        PRICES: {
            BOOKING_RATE: "Booking Rate",
            BOOKING_FEE: "Booking Fee",
            PER_BOOKING_FEE: "Per Booking Fee",
            CLIENT_RATE: "Client Rate",
            CANDIDATE_RATE: "Candidate Rate",
            AGENCY_FEE: "Agency Fee",
            TRAVEL_FEE: "Travel Fee",
            RUSH_FEE: "Rush Fee",
            CANDIDATE_RUSH_FEE: "Candidate Rush Fee",
            PER_BOOKING_AGENCY_FEE: "Per Booking Agency Fee",
            PER_BOOKING_CANDIDATE_FEE: "Per Booking Candidate Fee",
            ADMIN_FEE: "Admin Fee",
            ADMIN_PERCENTAGE: "Admin Percentage",
            ADDITIONAL_FEES: "Additional Fees"
        }
    },
    BOOKING_DIALOG: {
        LABEL: {
            ADDITIONAL_DATES: "Add Additional Dates",
            START_TIME: "Start Time",
            END_TIME: "End Time",
            END_DATE: "End Date",
            SELECT_CLIENT: "Select Client",
            ASSIGNED_CANDIDATE: "Do you want to assign this job?",
            TENTATIVELY_ASSIGN_CANDIDATE: "Do you want to tentatively assign this job?",
            REPEAT: "Do you want this service more than once (repeating/recurring)?",
            REPEAT_UNTIL: "Repeat Until",
            REPEAT_EVERY: "Repeat Every",
            REPEAT_ON: "Repeat On",
            BOOKING_ADDRESS: "Booking Address",
            ADDRESS_LINE2: "Address Line 2",
            CITY: "City",
            STATE: "State/Province",
            ZIP_CODE: "Zip Code",
            NUMBER_CHILDREN: "How many children will be cared for?",
            SELECT_JOB_CATEGORY: "Select Job Category",
            SELECT_DATE: "Booking Date",
            SELECT_SERVICE: "Select Service",
            SELECT_QUICKBOOKS_PRICE: "Select Price",
            NUMBER_CANDIDATE: "Number of {0} Needed",
            SELECT_STATUS: "Select Booking Status",
            CHECK_EXISTING: "Check for Existing",
            INVALID_BOOKING_DURATION: "Booking must be at least {0} hours"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Days", "Weeks"],
            REPEAT_ON: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
            ]
        }
    },
    MENU_BAR: {
        TOP: {
            COMMUNITY: "Community",
            CANDIDATE_COMMUNITY: "Candidate Community",
            MARKETPLACE: "Marketplace",
            MESSAGES: "Messages",
            SMS: "SMS",
            JOBS: "Jobs",
            LOGOUT: "Logout",
            DASHBOARD: "My Dashboard"
        },
        ADMIN: {
            USERS: {
                ROOT: "Users",
                CLIENTS: "Clients",
                CANDIDATES: "Candidates",
                ADMINISTRATORS: "Administrators"
            },
            JOBS_EVENTS: {
                ROOT: "Jobs & Calendar",
                SHIFT_JOB_CALENDAR: "Shift Job Calendar",
                PLACEMENT_JOBS: "Placement Jobs",
                PERSONAL_TO_DO: "Personal To Do"

            },
            TEMPLATES: {
                ROOT: "Templates",
                EMAIL: "Email Templates",
                SMS: "SMS Templates",
                DOCUMENT: "Document Templates",
                NOTE: "Note Templates",
                TASK: "Task Templates",
                PROFILE: "Profile Templates",
                PUSH_NOTIFICATION: "Push Notification Templates"
            },
            SETTINGS: {
                ROOT: "Settings",
                AGENCY: "Agency Settings",
                ADMIN: "Admin Settings"
            },
            BUILDERS: {
                ROOT: "Builders",
                PROFILE: "Application & Profile Builder",
                EVALUATION: "Evaluation Builder"
            },
            LOGS: {
                ROOT: "Logs",
                COMMUNICATION_LOG: "Communication Log",
                STATUS_CHANGES: "Status Changes",
                ACTIVITY_LOG: "Activity Log",
                APPLICATION_LOG: "Application Log",
                PAYMENT_LOG: "Payment Log",
                USER_MESSAGES_LOG: "User Chat Log",
            },
            OTHERS: {
                ROOT: "Others",
                RESOURCE_MANAGER: "Resource Manager",
                REFERENCES: "References",
                DOCUMENTS: "Documents",
                EMAIL_BLASTER: "Email Blaster",
                NOTIFICATION_CENTER: "Notification Center",
                SNAPSHOT: "Metrics & Analysis (Snapshot)",
                COMMUNITY: "Community",
                DAILY_RESOURCE_MANAGER: "Daily Resource Manager",
                GLOBAL_PREDEFINED_VALUES: "Global Predefined Values",
                BENEFIT_MANAGER: "Benefit Manager",
                BENEFITS: "Benefits",
                TRASH: "Trash Bin"
            }

        },
        CANDIDATES: {
            MY_PROFILE: "My Profile",
            AVAILABLE_JOBS: "Available Jobs",
            MY_SCHEDULE: "My Schedule",
            MY_JOBS: "My Jobs",
            MY_FAMILIES: "My Families",
            BENEFITS: "Benefits"
        },
        ADMIN_PANEL: {
            LISTS: "Lists",
            NOTES: "Notes",
            EMAIL_SMS: "Email/SMS",
            EVENT: "Schedule Event",
            PASSWORD: "Password",
            PAYMENTS: "Payments",
            PAYMENTS_CREDIT: "Payments/Credits",
            DOCUMENTS: "Documents",
            EVALUATIONS: "Evaluations",
            RELATIONSHIPS: "Assigned Candidates"
        },
        ADMIN_PANEL_SHORT: {
            EMAIL_SMS: "Email/ SMS",
            EVENT: "Event",
            PASSWORD: "Pass",
            DOCUMENTS: "Docs",
            EVALUATIONS: "Evals",
            PAYMENTS: "$$$",
            RELATIONSHIPS: "Assign Cands"
        }
    },
    NAV_BAR: {
        TOP: "Top",
        CHECKLIST: "Checklist",
        DOCUMENTS: "Documents",
        PHOTO_GALARY: "Photo Gallery",
        INTRODUCTION_VIDEO: "Introduction Video"
    },
    ENGINEHOW: {
        PROFILE_BUILDER: {
            BASIC: "Profile Builder Basics",
            REQUIRE_FIELD: "How to mark questions/field as required or not",
            NOTIFICATION_DESTINATION: "Edit Who is Notified of New Applicants",
            EDIT_APPLICATION: "How to edit application forms more easily",
            ADD_SECTION_QUESTION: "How to add a question to a section",
            ADD_CONFIRMATION_BOX: "How to add confirmation fields on client or candidate application forms"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Getting Started With Evaluations"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: "Getting Started With Email Templates",
            DEFAULT_EMAIL_FOOTER: "Setting Up Your Default Email Footer"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Getting Started With Document Templates",
            NOTIFICATION_WHEN_SIGNED: "Add Notification When Document Signed",
            ADD_DOCUMENT: "Manually Add a Document to a User"
        },
        AGENCY: {
            STATUSES_CHECKLISTS_TYPES: "Mapping Out Your Process Through Statuses, Checklists and Types",
            AGENCY_BRANDING_SETUP: "Agency Branding Set Up (Logo, Colors, Fonts)",
            PROFILE_COMPLETE_SETUP: `How to Add a "My Profile is Complete" Button Candidates can Click to Notify You They Have Completed Their Profile`,
            CONFIGURE_MULTIPLE_LOCATIONS: "Configure Your Agency to Service Multiple Distinct Locations"
        },
        EMAIL_BLASTER: {
            HOW_TO: "How email blasts work"
        },
        CLIENTS: {
            SHARE_CANDIDATE_PROFILE: "How to share a candidate's profile with a client"
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Welcome to {0} Mission Control",
        PRO_TIP: {
            HEADER: "Check out what's new:",
            TEXT: "Bulk shift job broadcasting!"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Order Clients By",
            ORDER_CANDIDATES_BY: "Order Candidates By"
        },
        BUTTONS: {
            ADD_CLIENT: "Add Client",
            ADD_CANDIDATE: "Add Candidate",
        },
    },
    ADD_USER_DIALOG: {
        HEADER: "Add New User",
        DESCRIPTION: `This is a mechanism to manually add a user to your database. A user
        added in this way will be put into the "Pre Application" status
        (meaning they have not yet completed an application form). A user in
        this status can still be sent to complete the application form. If you
        would like to automatically send an email to users added this way, you
        can add an email template that is a "Status Change Notification"
        triggering on a change to "Pre Application".`,
        LABELS: {
            EMAIL: "Email",
            PHONE: "Phone Number",
            FIRST_NAME: "First Name",
            LAST_NAME: "Last Name",
            PROFILE_BUILDER: "Profile Builder",
            USER_TYPES: "User Types",
            LOCATIONS: "Locations",
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Your account has been successfully connected with Stripe.",
        FAILED_TO_CONECT: "There was a problem connecting your account with Stripe, please try again or contact Enginehire.",
        MISSING_INFO: "Your account has been connected but there is missing information on the Stripe application, please click the connect to stripe button to continue where you left off",
    },
    DATA_TABLE: {
        SHOW: "Show",
        ITEMS_PER_PAGE: "items per page",
        SHOWING_RANGE: "Showing {0} to {1} of {2} entries"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Admin",
            PROFILE: "Profile",
            INTAKE_NOTES: "Intake Notes",
            COMMUNICATION_LOG: "Communication Log",
            RECORDS: "Records",
            JOBS: "Jobs",
            INTAKE_NOTES_MOBILE: "Notes",
            COMMUNICATION_LOG_MOBILE: "Com Log"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profile",
            NOTES: "Notes"
        },
        BUTTONS: {
            DELETE_CLIENT: "Delete Client"
        },
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Admin",
            PROFILE: "Profile",
            INTERVIEW: "Interview",
            COMMUNICATION_LOG: "Communication Log",
            RECORDS: "Records",
            COMMUNICATION_LOG_MOBILE: "Com Log"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profile",
            INTERVIEW: "Interview"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Delete Candidate"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Types",
            BUTTON: "Save Types"
        },
        CHECKLIST: {
            TITLE: "Checklist",
            BUTTON: "Save Checklist"
        },
        TAGS: {
            TITLE: "Tags",
            BUTTON: "Save Tags"
        },
        LOCATIONS: {
            TITLE: "Locations",
            BUTTON: "Save Locations"
        },
        LANGUAGE: {
            TITLE: "Language",
            BUTTON: "Save Language"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Profile Type",
            BUTTON: "Update Profile Builder"
        },
        NOTES: {
            TITLE: "Notes",
            DESCRIPTION: "Notes taken here are for internal admin use only, not visible to users.",
            BUTTON: "Add Note"
        },
        EMAIL: {
            TITLE: "Send Email",
            BUTTON_SEND: "Send",
            BUTTON_LOAD: "Load",
            SELECT_TEMPLATE: "Select Template",
            FROM_EMAIL: "From Email",
            REPLY_TO: "Reply To",
            SUBJECT: "Subject"
        },
        SMS: {
            TITLE: "Send SMS",
            BUTTON: "Send"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "You can manually reset the user's password here",
            BUTTON: "Update Password"
        },
        EVENT: {
            TITLE: "Schedule Event (Interview, Meeting, etc.)",
            DESCRIPTION: "These events will appear in the user's dashboard.",
            EVENT_TITLE: "Event Title",
            EVENT_DATE: "Event Date",
            EVENT_TIME: "Event Time",
            INTERVIEW_LINK: "Interview Link",
            INTERVIEW_LINK_PLACE_HOLDER: "Zoom link or other call link",
            NOTES: "Notes",
            STATUS_UPDATE_TO: "{0} to Update User to",
            SEND_EMAIL_NOTIFICATION: "Send email notification of event being scheduled",
            ADD_TO_CALENDAR: "Add to Personal To Do Calendar",
            BUTTON: "Schedule Event"
        },
        CREDIT: {
            TITLE: "Credits",
            BUTTON_ADD: "Add Credit",
            BUTTON_EDIT: "Edit",
            EDIT_CREDIT_TITLE: "Edit Credit",
            ADD_CREDIT_TITLE: "Add Credit",
            PLACE_HOLDERS: {
                VALUE: "Value",
                NOTES: "Notes"
            }
        },
        STRIPE: {
            BILL_CLIENT: "You can manually bill clients through Stripe here",
            SEND_INVOICE: "You can manually send Stripe Invoices here",
            BUTTON_CHARGE: "Charge Through Stripe",
            BUTTON_RESET: "Reset Stripe Information",
            BUTTON_INVOICE: "Invoice Through Stripe",
            PAYMENT_LOGS: "Payment Logs"
        },
        AUTHORIZE_NET: {
            BILL_CLIENT: "You can manually bill clients through Authorize.Net here",
            SEND_INVOICE: "You can manually send Authorize.Net Invoices here",
            BUTTON_CHARGE: "Charge Through Authorize.Net",
            BUTTON_RESET: "Reset Authorize.Net Information",
            BUTTON_INVOICE: "Invoice Through Authorize.Net",
            PAYMENT_LOGS: "Payment Logs"
        },
        REVIEW: {
            TITLE: "Reviews",
            RATING: "Rating",
            AVERAGE_RATING: "Average Rating",
            NO_DATA: "No reviews yet."
        },
        ADD_DOCUMENT: {
            TITLE: "Add Document",
            DESCRIPTION: `You can add any Document Template to the user from here, just select one
            of your documents from the drop down:`,
            BUTTON: "Add Document",
        },
        ADD_EVALUATION: {
            BUTTON: "Add Evaluation",
        },
        RELATIONSHIP: {
            CANDIDATE: {
                TITLE: "Assigned Candidates",
                NO_CANDIDATE: "No candidates have been linked to this client."
            },
            CLIENT: {
                TITLE: "Assigned Clients",
                NO_CLIENT: "No clients have been linked to this candidate."
            },
            ADD_CANDIDATE: "Add Candidate"
        },
        LAST_CONTACTED_DATE: "Last Contacted Date",
        CANDIDATE_BADGES: {
            TITLE: "Badges",
            BUTTON: "Save badges"
        }
    },
    COMMUNICATION: {
        DATE: "Date",
        FROM: "From",
        TO: "To",
        SUBJECT: "Subject",
        MESSAGE: "Message",
        RE_SEND: "Re-Send",
        CANCEL_SCHEDULE: "Cancel Schedule",
        SCHEDULE_TIME: "Schedule Time",
        CC: "Cc",
        BCC: "Bcc"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Search by Poster Name, Job Title, Job ID, Schedule, City, State, or Description",
        JOB_HIDEN_DESCRIPTION: `Jobs in the status {0} do not appear on the job
        board by default. To update a job's status please click "Edit Job".`,
        CLIENT_POSTING_JOB_DESCRIPTION: "This is for posting longer term positions for this client.",
        ADMIN_POSTING_JOB_DESCRIPTION: "This is for posting longer term positions",
    },
    CONFIRM_DIALOGS: CONFIRM_DIALOGS,
    ERROR_DIALOGS: ERROR_DIALOGS,
    RESULT_DIALOGS: RESULT_DIALOGS,
    AGENCY_SETTINGS: AGENCY_SETTINGS
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/en.js